import { css } from '@linaria/core'

const styles = css`
  @apply flex flex-col items-center justify-center;

  & .status-container {
    @apply p-2 rounded-2xl bg-n1-error-500 shadow-md;

    &.success {
      @apply bg-n1-success-500;
    }

    &.pending {
      @apply bg-n1-warning-500;
    }

    & .icon {
      @apply w-12 h-12;

      &:not(.clock) {
        & > path {
          @apply fill-white;
        }
      }

      &.clock {
        @apply p-0.5;
      }
    }
  }

  & .message {
    @apply text-sm tracking-wider text-center font-light pt-5;
  }
`

export default styles
